import { render, staticRenderFns } from "./SelectWords.vue?vue&type=template&id=5c41c862&scoped=true&"
import script from "./SelectWords.vue?vue&type=script&lang=js&"
export * from "./SelectWords.vue?vue&type=script&lang=js&"
import style0 from "./SelectWords.vue?vue&type=style&index=0&id=5c41c862&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c41c862",
  null
  
)

export default component.exports